import { render } from "./DrugPrice.vue?vue&type=template&id=fdbfd732&scoped=true"
import script from "./DrugPrice.vue?vue&type=script&lang=js"
export * from "./DrugPrice.vue?vue&type=script&lang=js"

import "./DrugPrice.vue?vue&type=style&index=0&id=fdbfd732&scoped=true&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbfd732"]])

export default __exports__